
import React, { Component } from 'react';
import PhoneInput from 'react-phone-number-input';
import { getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import { change } from 'redux-form';

class InputPhoneNumber extends Component {
  constructor() {
    super();
    this.state = { phone: "" };
  }

  onChange(phone){
    if (!phone) {
      this.props.changeFieldValue(this.props.meta.form, this.props.input.name, null)
      return;
    }
    this.props.changeFieldValue(this.props.meta.form, this.props.input.name, phone)
  }
  render(){
    const { error, touched, defaultCountry } = this.props;
    const countries = ["US", "IL", "FR", "CA", "CH", "GB"]
    return (
        <div className="nput-group" style={ {   verticalAlign: "baseline",}} >
        <PhoneInput
          country={defaultCountry}
          countries={countries}
          style={ {   verticalAlign: "baseline",}}
          value={this.props.initvalue }
          onChange={ phone => this.onChange( phone ) }
          type="phone"
          noValidate
          />
        {touched && error && <div><span className="text-danger">{error}</span></div>}
        </div>

    );
  }
}

const viewMapStateToProps = (state) => {
  return{
    currentLanguage: getActiveLanguage(state.locale).code
  }
}

const viewMapDispatchToProps = (dispatch) => {

  return {
    changeFieldValue: (form, field, value) => {
      dispatch(
        change(form, field, value)
      );
    },
  };
};
InputPhoneNumber = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(InputPhoneNumber);

export default InputPhoneNumber;
// return bindActionCreators({ setActiveLanguage }, dispatch);



// WEBPACK FOOTER //
// ./src/lib/forms/inputPhoneNumber.js